<script setup lang="ts">
import { ChipTag } from '@caks/uikit/chip'
</script>

<template>
  <header class="sub-header">
    <div class="sub-header__container main-container">
      <ul class="sub-header__chips">
        <slot />
      </ul>
      <div class="sub-header__additional">
        <chip-tag :active="$route.name === 'About'" bigger @click="$router.push('/about')">
          О компании
        </chip-tag>
        <chip-tag :active="$route.name === 'Contacts'" bigger @click="$router.push('/contacts')">
          Контакты
        </chip-tag>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.sub-header {
  background-color: $white;
  max-width: 1336px;
  margin: 0 auto;

  &__container {
    /* height: 42px; */
    padding: 8px;
    border-radius: 30px;
    background-color: $ui-gray-1;
    display: flex;
    justify-content: space-between;
  }

  &__chips {
    display: flex;
    max-width: 85%;
    overflow-x: scroll;
    gap: 5px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__additional {
    display: flex;
    gap: 10px;
  }
}
</style>
